import React, { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { useVersionsQuery, VersionsQuery } from 'src/graphql/_generated';
import { isQueryLoading } from 'src/graphql';

type UseVersionV2 = (props: { assessmentId?: string }) => {
  versionId: string | undefined;
  version: NonNullable<VersionsQuery['assessment']>['versions'][number] | undefined;
  versions: NonNullable<VersionsQuery['assessment']>['versions'] | undefined;
  isLoading: boolean;
};

export const useVersionV2: UseVersionV2 = ({ assessmentId }) => {
  const { search } = useLocation();
  const [versionId, setVersionId] = useState<string | undefined>(undefined);

  const {
    data: versions,
    networkStatus,
    loading,
  } = useVersionsQuery({
    variables: { assessmentId: assessmentId! },
    skip: !assessmentId,
  });
  const isLoading = isQueryLoading({ networkStatus, data: versions, loading });

  useLayoutEffect(() => {
    const parsedQuery = qs.parse(search, {
      ignoreQueryPrefix: true,
      strictNullHandling: true,
      plainObjects: true,
      depth: 1,
      decoder: (s) => s,
    });

    if (parsedQuery.version) {
      setVersionId(parsedQuery.version as string);
    } else {
      setVersionId(undefined);
    }
  }, [search]);

  return {
    versionId,
    version: versions?.assessment?.versions?.find((v) => v.id === versionId),
    versions: versions?.assessment?.versions || [],
    isLoading,
  };
};
